import React, { Fragment } from 'react';
import { useFormikContext } from 'formik';
import { useCallbackPrompt } from '../../../hooks/useCallbackPrompt';
import { Dialog, Transition } from '@headlessui/react';
import IconButton from '../../buttons/IconButton';

const UnsavedWarning = ({ submit, submitting, isValid }) => {
  const saveAndLeave = () => {
    submit()
      .then(confirmNavigation)
      .catch((e) => {
        cancelNavigation();
        console.error(e);
      });
  };

  const { dirty, touched } = useFormikContext();

  const shouldBlock = dirty && Object.keys(touched).length > 0;
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(shouldBlock);

  return (
    <Transition appear show={showPrompt} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto align-middle"
        static
        open={showPrompt}
        onClose={cancelNavigation}
      >
        <div className="min-h-screen w-screen sm:px-4 text-center flex items-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300 opacity-30"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-neutral-100 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="flex flex-col items-center w-full mx-auto max-w-md sm:max-w-xl p-10 my-12 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <div className="flex items-start justify-between">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-neutral-900"
                >
                  Leave page? You have unsaved changes.
                </Dialog.Title>
              </div>

              <div className="col-span-3 flex flex-col md:flex-row gap-2 justify-end mt-6">
                <IconButton
                  type="button"
                  text="Cancel"
                  style="outline"
                  classes="max-w-[8rem]"
                  handleClick={cancelNavigation}
                />
                <IconButton
                  text="Leave Without Saving"
                  style="outline"
                  type="button"
                  handleClick={confirmNavigation}
                />
                <IconButton
                  text="Leave and Save"
                  type="button"
                  style="primary"
                  handleClick={saveAndLeave}
                  disabled={submitting || !isValid}
                />
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default UnsavedWarning;
